<template>
  <div class="main-container" :class="colorMode === 'dark' ? 'dark-block' : ''">
    <h2>Need seamless access to registry documents?</h2>
    <p>
      Many African markets are ill-equipped to meet global diligence requirements without having boots on the ground. Our corporate document retrieval service combines our on-the-ground presence with the tech to feed you the digitised date you need.
    </p>
    <div class="action-wrap">
      <a
        @click="openLink"
        class="cta-button"
        :class="colorMode === 'light' ? 'medium-button' : ''"
        >Compliance Support</a
      >
    </div>
  </div>
</template>

<script>
export default {
  name: 'corp-docs',
  props: {
    colorMode: {
      type: String,
    },
  },
  methods: {
    openLink() {
      this.$ga.event({
        eventCategory: 'Click',
        eventAction: 'Conversion',
        eventLabel: 'Corp Docs Block',
      })
      this.$gtag.event('Conversion', {
        'event_category': 'Click',
        'event_label': 'Corp Docs Block',
      })
      this.$router.push({ path: '/about/solutions#compliance-support' })
    },
  },
}
</script>
